// extracted by mini-css-extract-plugin
module.exports = {"story":"Story_story__2upCg","transitionVideo":"Story_transitionVideo__18aPy","loaded":"Story_loaded__UoRuE"};